import React from 'react'
import styles from './Week.scss'
import { Day } from '../Day'
import { WeekMetaCell } from '../WeekMetaCell'
import PropTypes from 'prop-types'

export class Week extends React.PureComponent {
  static propTypes = {
    range: PropTypes.array.isRequired
  }

  render () {
    const { events, date, range, trips, hideTotals, ...props } = this.props
    const tripsForMeta = trips.filter(t => !t.excludeFromTotals)

    return (
      <div className={styles.Week}>
        {range.map((d, i) => (
          <Day
            key={i}
            date={date}
            events={events}
            range={d}
            {...props} />
        ))}
        {!hideTotals && <WeekMetaCell
          intl={props.intl}
          trips={tripsForMeta} />}
      </div>
    )
  }
}
